import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _AddKpi, _DeleteKpiEmploye, _ExecuteKpis, _Kpi } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectProccessTypeConstants } from "../../../erp/cellEditor/CashRequest/FactoryDocument/SelectProccessTypeConstants";
import { BasicButton } from "../../../theme/Component/BasicButton";
import usePaginator from "../../../theme/Component/usePaginator";
import { InputDate } from "../../../theme/Input/InputDate";
import { SelectFunctionalID } from "../../../admin/configuracion/functionalID/SelectFunctionalID";
import { AccountEditor } from "../../../editor/AccountEditor";
import { KpiConstantTypes } from "./KpiConstantTypes";
import { KpiConstantMeasurement } from "./KpiConstantMeasurement";
import { MonthEditorbyconst } from "../../../RemoteAbstractAction/editors/MonthEditorbyconst";
import { DayConstantList } from "./DayConstantList";
import { StrategicObjectiveEditortwo } from "../StrategicObjetive/StrategicObjectiveEditortwo";
import { KpiMeasurementCatalog } from "./KpiMeasurementCatalog";
import { KpiConstantLevelTypes } from "./KpiConstantLevelTypes";
import { KpiDashEditor } from "../KpiDashBoard/KpiDashEditor";
import { DashBoardCatalogByKpi } from "./DashBoardCatalogByKpi";
interface propsData {
    fromDate: any;
    uptoDate: any;
    excDate: any;
}

export const Kpibycatalog = () => {

    const { instance, bean, setBean, handleChange } = useDataBean(_Kpi);
    const executeKpis = useDataBean(_ExecuteKpis);
    const addkpi = useDataBean(_AddKpi);
    const deletebean = useDataBean(_DeleteKpiEmploye);
    const paginador = usePaginator();
    const [data, setData] = useState<Partial<propsData>>({});
    const [regexStr, setregexStr] = useState<any>(null);
    const [lista, setLista] = useState<any>([]);
    const [processType, setprocessType] = useState<number>(null)
    const [form, setForm] = useState<any>({
        IDStrategicObjective: null,
        Name: null,
        IDLnFunctionalID: null,
        Account: _single.getAccountID()
    })
    const [modaladddash, setModaladddash] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalviewdash, setModalviewdash] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalconsultmed, setModalconsultmed] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalkpimed, setModalkpimed] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalkpirang, setModalkpirang] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalkpirangdelete, setModalkpirangdelete] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {
        instance.getKpiCatalog(processType, form.IDStrategicObjective, form.IDLnFunctionalID, form.Account, null, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.StrategicObjName = (user.DataBeanProperties.StrategicObjectiveName ?? "") + "-" + (user.DataBeanProperties.StrategicObjectiveDescription ?? "");
                        user.DataBeanProperties.NameArea = (user.DataBeanProperties.FunctionalIDJsonCode ?? "") + "-" + (user.DataBeanProperties.FunctionalIDName ?? "");
                    });
                    setLista(x)
                }
            }
        )
    }
    const addKpiToDashBoard = () => {

        addkpi.instance.addKpiToDashBoard(addkpi.bean.IDDashBoard, bean.IDKpi).then(
            (resp: any) => {

                toast.success('Kpi Agregada');
                setModaladddash({ ...modaladddash, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const create = () => {
        setBean({});
        setModal({ ...modal, "view": true });
    }

    const deleteItem = () => {
        instance.deleteKpi(bean.IDKpi).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }

    const editaItem = () => {
        instance.updateKpi(bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const ExecuteKpis = () => {
        executeKpis.instance.executeKpis(data.excDate, bean.IDKpi, _single.getAccountID()).then(
            (resp: any) => {
                setData({});
                getLista();
                setModalkpimed({ ...modalkpimed, "view": false });
                toast.success("Se realizo la Acción");
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const ExecuteKpisTWO = () => {
        executeKpis.instance.executeKpisRange(data.fromDate, data.uptoDate, bean.IDKpi, _single.getAccountID()).then(
            (resp: any) => {
                setData({});
                getLista();
                setModalkpirang({ ...modalkpirang, "view": false });
                toast.success("Se realizo la Acción");
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteKpiEmployeeMeasurement = () => {
        deletebean.instance.deleteKpiEmployeeMeasurement(bean.IDKpi, deletebean.bean.fromDate, deletebean.bean.uptoDate).then(
            (resp: any) => {
                getLista();
                setModalkpirangdelete({ ...modalkpirangdelete, "view": false });
                toast.success("Se realizo la Acción");
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const head = [
        { title: 'ID', property: 'IDKpi', visible: true },
        { title: 'Objetivo Estratégico', property: 'StrategicObjName', visible: true },
        { title: 'Area Organizacional', property: 'NameArea', visible: true },
        { title: 'Nivel de Medición', property: 'KpiLevelName', visible: true },
        { title: 'Tipo Medición', property: 'MeasurementTypeName', visible: true },
        { title: 'Tipo de Proceso', property: 'ProcessTypeName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Responsable del Indicador', property: 'AccountName', visible: true },
        { title: 'Fecha Creacion', property: 'Since', visible: true },
        { title: 'Última Actualización', property: 'LastUpdate', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Ejecutar Medición KPI', icono: 'ri-inbox-unarchive-line', visible: _single.canDelete(), evento: () => { setModalkpimed({ ...modalkpimed, "view": true, name: "Ejecutar Medición KPI" }) } },
            { titulo: 'Ejecutar Medición KPI en un rango', icono: 'ri-inbox-unarchive-fill', visible: _single.canDelete(), evento: () => { setModalkpirang({ ...modalkpirang, "view": true, name: "Ejecutar Medición KPI en un rango" }) } },
            { titulo: 'Eliminar Rango de Mediciones', icono: 'ri-file-reduce-fill', visible: _single.canDelete(), evento: () => { setModalkpirangdelete({ ...modalkpirangdelete, "view": true, name: "Eliminar Rango de Mediciones" }) } },
            { titulo: 'Consultar Mediciones del Indicador', icono: 'ri-search-eye-fill', visible: _single.canDelete(), evento: () => { setModalconsultmed({ ...modalconsultmed, "view": true, name: "Consultar Mediciones del Indicador" }) } },
            { titulo: 'Agregar a Tablero de Control', icono: 'ri-add-circle-fill', visible: _single.canDelete(), evento: () => { setModaladddash({ ...modaladddash, "view": true, name: "Agregar a Tablero de Control" }) } },
            { titulo: 'Consultar Tableros de Control', icono: 'ri-eye-2-line', visible: _single.canDelete(), evento: () => { setModalviewdash({ ...modalviewdash, "view": true, name: "Consultar Tableros de Control" }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${bean.Name}`, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Mis Indicadores">
            <div className="row">
                <div className="col-md-6">
                    <SelectProccessTypeConstants idSelector={processType} onChange={(e) => { setprocessType(e) }} />
                </div>
                <div className="col-md-6">
                    <StrategicObjectiveEditortwo render={form.Name} idSelector={form.IDStrategicObjective} onChange={(e) => { setForm({ ...form, "IDStrategicObjective": e.IDStrategicObjective, "Name": e.Name }) }} returnType="Object" />
                </div>
                <div className="col-md-6">
                    <SelectFunctionalID label='Area Organizacional' functionalIDLn={form.IDLnFunctionalID} onChange={(e: any) => { setForm({ ...form, "IDLnFunctionalID": e.IDLn }) }} />
                </div>
                <div className="col-md-6">
                    <AccountEditor disabled={true} idAccount={form.Account} onChange={(e: any) => { setForm({ ...form, "Account": e.IDAccount }) }} label="Responsable del Indicador" />
                </div>
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Consultar
                    </BasicButton>
                </div>

                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} records={paginador} ></BasicTable>

                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <SelectProccessTypeConstants idSelector={bean.ProcessType} onChange={(e) => { setBean({ ...bean, "ProcessType": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <StrategicObjectiveEditortwo render={bean.StrategicObjectiveName} idSelector={bean.IDStrategicObjective} onChange={(e) => { setBean({ ...bean, "IDStrategicObjective": e.IDStrategicObjective, "StrategicObjectiveName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <SelectFunctionalID label='Area Organizacional' functionalIDLn={bean.IDLnFunctionalID} onChange={(e: any) => { setBean({ ...bean, "IDLnFunctionalID": e.IDLn }) }} />
                            </div>
                            <div className="col-md-6">
                                <KpiConstantLevelTypes idSelector={bean.KpiLevel} onChange={(e: any) => { setBean({ ...bean, "KpiLevel": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <KpiConstantTypes idSelector={bean.Type} onChange={(e) => { setBean({ ...bean, "Type": e }) }} />
                            </div>
                            {bean.Type === 2 && (
                                <div className="row">
                                    <div className="col-md-12 mt-3">
                                        <label>SQL Query</label>
                                        <textarea
                                            name="SQLQuery"
                                            className="form-control"
                                            value={bean.SQLQuery}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            )}

                            {bean.Type === 6 && (
                                <div className="row">
                                    <div className="col-md-12 mt-3">
                                        <label>Class For Name</label>
                                        <textarea
                                            name="ClassForName"
                                            className="form-control"
                                            value={bean.ClassForName}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            )}

                            <div className="col-md-6">
                                <KpiConstantMeasurement idSelector={bean.MeasurementType} onChange={(e) => { setBean({ ...bean, "MeasurementType": e }) }} />
                            </div>
                            {bean.MeasurementType === 10 && (
                                <div className="row">
                                    <div className="col-md 6">
                                        <MonthEditorbyconst idSelector={bean.Month} onChange={(e) => { setBean({ ...bean, "Month": e }) }} />
                                    </div>
                                    {bean.Month && <>

                                        <div className="col-md-6">
                                            <DayConstantList month={bean.Month} idSelector={bean.DayOfMonth} onChange={(e) => { setBean({ ...bean, "DayOfMonth": e }) }} />
                                        </div>
                                    </>}
                                    <div className="col-md-6">
                                        <label>Nombre</label>
                                        <input type="text" name="TimeDays" className="form-control" value={bean.TimeDays} onChange={(e) => { setBean({ ...bean, "TimeDays": e }) }} />
                                    </div>
                                </div>
                            )}
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={bean.Name} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <AccountEditor idAccount={bean.IDAccountResponsible} onChange={(e) => { setBean({ ...bean, "IDAccountResponsible": e.IDAccount }) }} label="Responsable del Indicador" />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={bean.Description} onChange={handleChange} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalkpimed} updateModal={setModalkpimed} eventModal={() => {
                        if (data.excDate) {
                            ExecuteKpis()
                        } else {
                            toast.error("Los campos son obligatorios")
                        }
                    }}>
                        <div className="row">
                            <div className="col-md-12">
                                <InputDate name="FromDate" label="Fecha Ejecución" value={data.excDate} setDate={(e: any) => { setData({ ...data, excDate: e }) }} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalkpirang} updateModal={setModalkpirang} eventModal={() => {
                        if (data.fromDate && data.uptoDate) {
                            ExecuteKpisTWO()
                        } else {
                            toast.error("Los campos son obligatorios")
                        }
                    }}>
                        <div className="row">
                            <div className="col-md-6">
                                <InputDate name="FromDate" label="Fecha de inicio" value={data.fromDate} setDate={(e: any) => { setData({ ...data, fromDate: e }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="UptoDate" label="Fecha hasta" value={data.uptoDate} setDate={(e: any) => { setData({ ...data, uptoDate: e }) }} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modaladddash} updateModal={setModaladddash} eventModal={addKpiToDashBoard}>

                        <KpiDashEditor render={bean.NameDash} idSelector={bean.IDDashBoard} onChange={(e) => { setBean({ ...bean, "IDDashBoard": e.IDDashBoard, "NameDash": e.Name }) }} returnType="Object" />

                    </Modal>
                    <Modal modal={modalviewdash} updateModal={setModalviewdash}>
                        <>

                            <DashBoardCatalogByKpi idKpi={bean.IDKpi} />
                        </>
                    </Modal>
                    <Modal modal={modalkpirangdelete} updateModal={setModalkpirangdelete} eventModal={deleteKpiEmployeeMeasurement}>
                        <div className="row">
                            <div className="col-md-6">
                                <InputDate name="FromDate" label="Fecha de inicio" value={deletebean.bean.fromDate} setDate={(e: any) => { deletebean.setBean({ ...deletebean.bean, 'fromDate': e }) }} />
                            </div>

                            <div className="col-md-6">
                                <InputDate name="UptoDate" label="Fecha hasta" value={deletebean.bean.uptoDate} setDate={(e: any) => { deletebean.setBean({ ...deletebean.bean, 'uptoDate': e }) }} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalconsultmed} updateModal={setModalconsultmed}>
                        <>
                            <KpiMeasurementCatalog idKpi={bean.IDKpi} />
                        </>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}